import React from "react";

const errorIcon = (
	<svg
		width="18"
		height="18"
		viewBox="0 0 18 18"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M3.43213 14.5679C4.92078 16.0567 6.89612 16.875 9 16.875C11.1039 16.875 13.0825 16.0567 14.5679 14.5679C16.0565 13.079 16.875 11.1041 16.875 9C16.875 6.89591 16.0565 4.91789 14.5679 3.43213C13.0825 1.94328 11.1039 1.125 9 1.125C6.89612 1.125 4.91748 1.94328 3.43213 3.43213C1.94348 4.91789 1.125 6.89591 1.125 9C1.125 11.1041 1.94348 13.0821 3.43213 14.5679ZM8.01562 5.0625C8.01562 4.51799 8.45508 4.07812 9 4.07812C9.54492 4.07812 9.98438 4.51799 9.98438 5.0625V9.98438C9.98438 10.5289 9.54492 10.9688 9 10.9688C8.45508 10.9688 8.01562 10.5289 8.01562 9.98438V5.0625ZM9.98438 12.9375C9.98438 12.393 9.54492 11.9531 9 11.9531C8.45508 11.9531 8.01562 12.393 8.01562 12.9375C8.01562 13.482 8.45508 13.9219 9 13.9219C9.54492 13.9219 9.98438 13.482 9.98438 12.9375Z"
			fill="#DA1414"
		/>
	</svg>
);

export default errorIcon;
